"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _of = require("rxjs/observable/of");

var _fromPromise = require("rxjs/observable/fromPromise");

var _filter = require("rxjs/operators/filter");

var _mergeMap = require("rxjs/operators/mergeMap");

var _map = require("rxjs/operators/map");

var _catchError = require("rxjs/operators/catchError");

var _startWith = require("rxjs/operators/startWith");

var _mapTo = require("rxjs/operators/mapTo");

var _reduxObservable = require("redux-observable");

var _actions = require("./actions");

var _selectors = require("./selectors");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _API = _interopRequireDefault(require("./API"));

var fetchMeetingsUserEntity = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getMeetingsUser,
  initiatingActionType: _actions.MeetingsActionTypes.FETCH_MEETINGS_USER,
  requestActions: _actions.FetchMeetingsUser,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.FETCH_MEETINGS_USER)
}));
var createMeetingsUserEntity = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.createMeetingsUser,
  initiatingActionType: _actions.MeetingsActionTypes.CREATE_MEETINGS_USER,
  requestActions: _actions.CreateMeetingsUser,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.CREATE_MEETINGS_USER)
}));
var fetchLinksEntity = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getMeetingsLink,
  initiatingActionType: _actions.MeetingsActionTypes.FETCH_LINKS,
  requestActions: _actions.FetchLinks,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.FETCH_LINKS)
}));
var verifyUserEntity = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.verifyUser,
  initiatingActionType: _actions.MeetingsActionTypes.VERIFY_USER,
  requestActions: _actions.VerifyUser,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.VERIFY_USER)
}));
var updateMeetingsLinkEntity = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.updateMeetingsLink,
  initiatingActionType: _actions.MeetingsActionTypes.UPDATE_MEETINGS_LINK,
  requestActions: _actions.UpdateMeetingsLink,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.UPDATE_MEETINGS_LINK)
}));
var validateNamespaceEntity = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.validateNamespace,
  initiatingActionType: _actions.MeetingsActionTypes.VALIDATE_NAMESPACE,
  requestActions: _actions.ValidateNamespace,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.VALIDATE_NAMESPACE)
}));
var disconnectMeetingsUserEntity = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.disconnectMeetingsUser,
  initiatingActionType: _actions.MeetingsActionTypes.DISCONNECT_MEETINGS_USER,
  requestActions: _actions.DisconnectMeetingsUser,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.DISCONNECT_MEETINGS_USER)
}));
var fetchEmailProviderEntity = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getEmailProvider,
  initiatingActionType: _actions.MeetingsActionTypes.FETCH_EMAIL_PROVIDER,
  requestActions: _actions.FetchEmailProvider,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.FETCH_EMAIL_PROVIDER)
}));
var fetchCalendarInfoEntity = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getCalendarInfo,
  initiatingActionType: _actions.MeetingsActionTypes.FETCH_CALENDAR_INFO,
  requestActions: _actions.FetchCalendarInfo,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.FETCH_CALENDAR_INFO)
}));
var verifyCalendarsEntity = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.verifyCalendars,
  initiatingActionType: _actions.MeetingsActionTypes.VERIFY_CALENDARS,
  requestActions: _actions.VerifyCalendars,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.VERIFY_CALENDARS)
}));
var fetchPrimaryCalendarEntity = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getPrimaryCalendar,
  initiatingActionType: _actions.MeetingsActionTypes.FETCH_PRIMARY_CALENDAR,
  requestActions: _actions.FetchPrimaryCalendar,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.FETCH_PRIMARY_CALENDAR)
}));
var fetchCustomHostedDomainsEntity = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getCustomHostedDomains,
  initiatingActionType: _actions.MeetingsActionTypes.FETCH_CUSTOM_HOSTED_DOMAINS,
  requestActions: _actions.FetchCustomHostedDomains,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.FETCH_CUSTOM_HOSTED_DOMAINS)
}));
var saveMeetingsUserEntity = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.saveMeetingsUser,
  initiatingActionType: _actions.MeetingsActionTypes.SAVE_MEETINGS_USER,
  requestActions: _actions.SaveMeetingsUser,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.MeetingsActionTypes.SAVE_MEETINGS_USER)
}));

var fetchMeetingsUserEpic = function fetchMeetingsUserEpic($action) {
  return $action.ofType(_actions.FetchMeetingsUserActionTypes.SUCCESS).pipe((0, _mergeMap.mergeMap)(function (action) {
    var actions = [(0, _actions.fetchLinks)(), (0, _actions.verifyUser)(), (0, _actions.fetchCalendarInfo)(), (0, _actions.fetchCustomHostedDomains)(), (0, _actions.verifyCalendars)()];

    if (!action.payload.data.calendarIdToWriteTo) {
      actions.push((0, _actions.fetchPrimaryCalendar)());
    }

    return _of.of.apply(void 0, actions);
  }));
};

var createMeetingsUserEpic = function createMeetingsUserEpic($action) {
  return $action.ofType(_actions.CreateMeetingsUserActionTypes.SUCCESS).pipe((0, _mapTo.mapTo)((0, _actions.fetchMeetingsUser)()));
};

var updateMeetingsLinkEpic = function updateMeetingsLinkEpic($action) {
  return $action.ofType(_actions.UpdateMeetingsLinkActionTypes.SUCCESS, _actions.UpdateMeetingsLinkActionTypes.FAILURE).pipe((0, _mapTo.mapTo)((0, _actions.fetchLinks)()));
};

var updateMeetingsLinkDomainEpic = function updateMeetingsLinkDomainEpic($action) {
  return $action.ofType(_actions.SaveMeetingsUserActionTypes.SUCCESS).pipe((0, _filter.filter)(function (action) {
    return action.payload.props.updatedCustomHostedDomainName;
  }), (0, _mapTo.mapTo)((0, _actions.fetchLinks)()));
};

var validateNamespaceEpic = function validateNamespaceEpic($action) {
  return $action.ofType(_actions.ValidateNamespaceActionTypes.SUCCESS).pipe((0, _filter.filter)(function (action) {
    return !action.payload.data;
  }), (0, _mapTo.mapTo)((0, _actions.userSettingsValidated)()));
};

var saveMeetingsUserEpic = function saveMeetingsUserEpic($action, _ref) {
  var getState = _ref.getState;
  return $action.ofType(_actions.MeetingsActionTypes.USER_SETTINGS_VALIDATED, _actions.FetchPrimaryCalendarActionTypes.SUCCESS).pipe((0, _mergeMap.mergeMap)(function () {
    var state = getState();
    var namespace = (0, _selectors.getStagedNamespace)(state);
    var calendarIntegrationChoice = (0, _selectors.getCalendarIntegrationChoice)(state);
    var calendarEmail = (0, _selectors.getCalendarEmail)(state);
    var calendarIdsToCheck = (0, _selectors.getStagedCalendarIdsToCheck)(state);
    var calendarIdToWriteTo = (0, _selectors.getCalendarIdToWriteTo)(state);
    var calendarDisplayNames = (0, _selectors.getStagedCalendarDisplayNames)(state);
    var stagedCustomHostedDomainName = (0, _selectors.getStagedCustomHostedDomainName)(state);
    var ewsUri = (0, _selectors.getStagedEwsUri)(state);
    var calendarUsername = (0, _selectors.getStagedCalendarUsername)(state);
    var customHostedDomain = (0, _selectors.getValidDomains)(state).toJS().find(function (_ref2) {
      var domain = _ref2.domain;
      return domain === stagedCustomHostedDomainName;
    });
    var stagedDefaultLinkId = (0, _selectors.getStagedDefaultLinkId)(state);
    var stagedChangesCount = (0, _selectors.getStagedChangesCount)(state);
    var updatedCustomHostedDomainName = Boolean((0, _selectors.getCustomHostedDomainNameChangesCount)(state));
    return (0, _of.of)((0, _actions.saveMeetingsUser)({
      namespace: namespace,
      calendarSettings: {
        provider: calendarIntegrationChoice,
        email: calendarEmail,
        calendarIdsToCheck: calendarIdsToCheck,
        calendarIdToWriteTo: calendarIdToWriteTo,
        calendarDisplayNames: calendarDisplayNames,
        ewsUri: ewsUri,
        username: calendarUsername
      },
      customHostedDomain: customHostedDomain,
      stagedDefaultLinkId: stagedDefaultLinkId,
      stagedChangesCount: stagedChangesCount,
      updatedCustomHostedDomainName: updatedCustomHostedDomainName
    }));
  }));
};

var updateMeetingsUserIntegrationEpic = function updateMeetingsUserIntegrationEpic($action, _ref3) {
  var getState = _ref3.getState;
  return $action.ofType(_actions.MeetingsActionTypes.UPDATE_MEETINGS_USER_INTEGRATION).pipe((0, _mergeMap.mergeMap)(function () {
    var state = getState();
    var namespace = (0, _selectors.getStagedNamespace)(state);
    var calendarEmail = (0, _selectors.getCalendarEmail)(state);
    var calendarIntegrationChoice = (0, _selectors.getCalendarIntegrationChoice)(state);
    var ewsUri = (0, _selectors.getStagedEwsUri)(state);
    var calendarUsername = (0, _selectors.getStagedCalendarUsername)(state);
    var props = {
      namespace: namespace,
      calendarSettings: {
        provider: calendarIntegrationChoice,
        email: calendarEmail,
        ewsUri: ewsUri,
        username: calendarUsername
      }
    };
    return (0, _fromPromise.fromPromise)(_API.default.saveMeetingsUser(props)).pipe((0, _map.map)(function (response) {
      return _actions.UpdateMeetingsUserIntegration.success(response, props);
    }), (0, _catchError.catchError)(function (error) {
      return (0, _of.of)(_actions.UpdateMeetingsUserIntegration.failure(error, props));
    }), (0, _startWith.startWith)(_actions.UpdateMeetingsUserIntegration.request(props)));
  }));
};

var updatedMeetingsUserIntegration = function updatedMeetingsUserIntegration($action) {
  return $action.ofType(_actions.UpdateMeetingsUserIntegrationActionTypes.SUCCESS).pipe((0, _mapTo.mapTo)((0, _actions.verifyUser)()));
};

var verifiedMeetingsUser = function verifiedMeetingsUser($action, _ref4) {
  var getState = _ref4.getState;
  return $action.ofType(_actions.VerifyUserActionTypes.SUCCESS).pipe((0, _mergeMap.mergeMap)(function () {
    var state = getState();
    var calendarInfo = (0, _selectors.getCalendarInfo)(state);
    var calendarIdToWriteTo = (0, _selectors.getCalendarIdToWriteTo)(state);
    var actions = [];

    if (!calendarInfo) {
      actions.push((0, _actions.fetchCalendarInfo)());
      actions.push((0, _actions.verifyCalendars)());
    }

    if (!calendarIdToWriteTo) {
      actions.push((0, _actions.fetchPrimaryCalendar)());
    }

    return _of.of.apply(void 0, actions);
  }));
};

var _default = (0, _reduxObservable.combineEpics)(fetchMeetingsUserEntity, createMeetingsUserEntity, fetchLinksEntity, verifyUserEntity, updateMeetingsLinkEntity, validateNamespaceEntity, disconnectMeetingsUserEntity, fetchEmailProviderEntity, fetchCalendarInfoEntity, verifyCalendarsEntity, fetchPrimaryCalendarEntity, fetchCustomHostedDomainsEntity, saveMeetingsUserEntity, validateNamespaceEpic, fetchMeetingsUserEpic, saveMeetingsUserEpic, updateMeetingsLinkEpic, updateMeetingsLinkDomainEpic, createMeetingsUserEpic, updateMeetingsUserIntegrationEpic, updatedMeetingsUserIntegration, verifiedMeetingsUser);

exports.default = _default;
module.exports = exports.default;